import { Component, Input } from '@angular/core';
import { NavContainerUtilComponent } from 'shared/utils/nav-container-util.component';

@Component({
  selector: 'app-infopost-nav-container',
  templateUrl: './infopost-nav-container.component.html',
  styleUrl: './infopost-nav-container.component.scss',
})
export class InfopostNavContainerComponent extends NavContainerUtilComponent {
  @Input()
  menuItemType: string;

}
